<template>
  <v-container fluid>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="5" xl="5" lg="5" md="5" sm="5">
            <p>
              {{ get("p-1.1") }} 
              {{ get("company") }}
              {{ get("p-1.2") }}
            </p>
          </v-col>
          <v-col cols="7" xl="7" lg="7" md="7" sm="7">
            <v-img :src="image" class="image"></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>{{ get("header-2") }}</h2>
            <p>
              {{ get("p-2.1") }}
            </p>
            <h2>{{ get("header-3") }}</h2>
            <p>
              {{ get("p-3.1") }}
            </p>
            <p>
              {{ get("p-3.2") }} 
              {{ get("company") }}
              {{ get("p-3.3") }}
            </p>
            <h2>{{ get("header-4") }}</h2>
            <p>
              {{ get("p-4.1") }} 
              {{ get("company")}}
              {{ get("p-4.2") }}
              <phonenumber phone="(303) 778-8010"></phonenumber>. 
              {{ get("p-4.3") }}
              <linkto :text="contact" to="/contact"></linkto> 
              {{ get("p-4.4") }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <guild></guild>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from '@/router'
import linkto from "@/components/controls/link-to";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";
export default {
  name: "Gutter-Home",

  components: {
    estimate,
    linkto,
    phonenumber
  },

  created() {
    this.pageName = "gutters";
  },

  data: () => ({
    image: require("@/assets/roof-7.jpeg"),
  }),

  mixins: [localizationMixin],

  methods: {
    onAbout() {
      router.push("/about/home");
    },
    getLocalization(){}
  },
};
</script>

<style lang="scss" scoped>
.after-image {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subtitle-span {
  background: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}
</style>
